"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DashboardOrders = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _startCase = _interopRequireDefault(require("lodash/startCase"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var DashboardOrders = function DashboardOrders(props) {
  var data = props.data,
      loading = props.loading;
  var currencySymbols = {
    GBP: '£',
    USD: '$',
    EUR: '€'
  };

  var formatAsCurrency = function formatAsCurrency() {
    var price = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GBP';
    return "".concat(currencySymbols[currency]).concat((price / 100).toFixed(2));
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "dashboard-table"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "table-column",
    style: {
      color: '#338CE4'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "header"
  }, "Most recent orders"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "view-all"
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/orders",
    activeClassName: "active"
  }, "View All"))), loading ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "table-column"
  }, "Orders Loading...") : /*#__PURE__*/_react["default"].createElement("div", null, !data || data <= 1 ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "table-column"
  }, "No results found") : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "table-column",
    style: {
      color: '#212529'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '25%'
    }
  }, "Order Reference"), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '25%'
    }
  }, "Email"), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '15%'
    }
  }, "Delivery Surname"), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '12%'
    }
  }, "Total (inc. tax)"), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '12%'
    }
  }, "Total (exc. tax)"), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '11%'
    }
  }, "Status")), data.map(function (order) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: order.id,
      className: "table-column"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        color: '#338CE4',
        width: '25%'
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, {
      to: "/orders/".concat(order.id),
      activeClassName: "active"
    }, order.reference)), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        width: '25%'
      }
    }, order.email), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        width: '15%'
      }
    }, order.deliveryAddress.surname), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        width: '12%'
      }
    }, formatAsCurrency(order.totalIncTaxAfterDiscount, order.currency)), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        width: '12%'
      }
    }, formatAsCurrency(order.totalExcTaxAfterDiscount, order.currency)), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        width: '11%'
      }
    }, (0, _startCase["default"])(order.status)));
  }))));
};

exports.DashboardOrders = DashboardOrders;